import { __decorate, __param } from 'tslib';
import { Pipe, NgModule, Inject, Input, Component, TemplateRef, ViewContainerRef, Directive } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';

const _c2 = function (a0) { return { "active": a0 }; };
const _c3 = ["*"];
let FileSizePipe = class FileSizePipe {
    /**
     * Returns a readable file size from bytes
     * @param  _size The file size in bytes
     * @returns The readable file size
     */
    transform(_size) {
        let size = _size;
        const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
        const unit = units.find(() => {
            if (size / 1024 >= 1) {
                size /= 1024;
                return false;
            }
            return true;
        });
        const roundedSize = Math.round(parseFloat(size.toFixed(2)) * 10) / 10;
        return `${roundedSize} ${unit}`;
    }
};
FileSizePipe.ɵfac = function FileSizePipe_Factory(t) { return new (t || FileSizePipe)(); };
FileSizePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "fileSize", type: FileSizePipe, pure: true });

let FileSizeModule = class FileSizeModule {
};
FileSizeModule.ɵfac = function FileSizeModule_Factory(t) { return new (t || FileSizeModule)(); };
FileSizeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FileSizeModule });
FileSizeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let SkipNavComponent = class SkipNavComponent {
    constructor(_document) {
        this._document = _document;
        this.active = false;
    }
    ngOnInit() {
    }
    onFocus() {
        this.active = true;
    }
    onBlur() {
        this.active = false;
    }
    focusMain() {
        const elem = this._document.getElementById(this.mainId);
        elem.focus();
    }
};
SkipNavComponent.ɵfac = function SkipNavComponent_Factory(t) { return new (t || SkipNavComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
SkipNavComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SkipNavComponent, selectors: [["skip-nav"]], inputs: { mainId: "mainId" }, ngContentSelectors: _c3, decls: 4, vars: 4, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_8142863558939371649$$FESM2015_CISCO_CUI_NG_UTILS_JS_1 = goog.getMsg("{$startTagNgContent}{$closeTagNgContent}", { "startTagNgContent": "\uFFFD#3\uFFFD", "closeTagNgContent": "\uFFFD/#3\uFFFD" }, { original_code: { "startTagNgContent": "<ng-content>", "closeTagNgContent": "</ng-content>" } });
        i18n_0 = MSG_EXTERNAL_8142863558939371649$$FESM2015_CISCO_CUI_NG_UTILS_JS_1;
    }
    else {
        i18n_0 = $localize `:␟6c097c33bae190f145ff96f5595e99b9be959f32␟8142863558939371649:${"\uFFFD#3\uFFFD"}:START_TAG_NG_CONTENT:${"\uFFFD/#3\uFFFD"}:CLOSE_TAG_NG_CONTENT:`;
    } return [[1, "skip-nav", "base-padding", 3, "ngClass"], ["tabindex", "0", 1, "text-size-20", 3, "routerLink", "fragment", "click", "focus", "blur"], i18n_0]; }, template: function SkipNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
        ɵngcc0.ɵɵlistener("click", function SkipNavComponent_Template_a_click_1_listener() { return ctx.focusMain(); })("focus", function SkipNavComponent_Template_a_focus_1_listener() { return ctx.onFocus(); })("blur", function SkipNavComponent_Template_a_blur_1_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵi18nStart(2, 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵi18nEnd();
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx.active));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fragment", ctx.mainId);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc2.RouterLinkWithHref], styles: [".skip-nav[_ngcontent-%COMP%]{position:fixed;left:0;top:-70px;z-index:9999;background-color:var(--cui-theme-primary);border-radius:0 0 20px;transition:top .2s}.skip-nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus{color:var(--cui-theme-primary-color)}.skip-nav.active[_ngcontent-%COMP%]{top:0}"] });
SkipNavComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
__decorate([
    Input()
], SkipNavComponent.prototype, "mainId", void 0);
SkipNavComponent = __decorate([ __param(0, Inject(DOCUMENT))
], SkipNavComponent);

/**
 * Component which implements "Skip to Main Content" navigation.
 * This is important for keyboard/screen reader accessibility
 *
 * This should typically be placed first in your tab navigation order
 *
 * It will remain hidden until it recieves keyboard focus. At that point
 * it animates to be visible with your chosen text. Hitting enter/clicking will
 * cause you to skip to the provided anchor
 *
 * Note in your router options you'll probably want to turn anchorScrolling on
 * so that you can navigate to pieces of the page with fragments
 * You also want to give your "main" element a tabIndex of -1 so it can be focused
 *
 * Note cng-layout has one of these included automatically
 */
let SkipNavModule = class SkipNavModule {
};
SkipNavModule.ɵfac = function SkipNavModule_Factory(t) { return new (t || SkipNavModule)(); };
SkipNavModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SkipNavModule });
SkipNavModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        RouterModule] });

class DataRefContext {
}
let DataRefDirective = class DataRefDirective {
    constructor(_templateRef, _vcr) {
        this._templateRef = _templateRef;
        this._vcr = _vcr;
        this._context = new DataRefContext();
        this._vcr.createEmbeddedView(this._templateRef, this._context);
    }
    set dataRefFrom(value) {
        Object.assign(this._context, value);
    }
};
DataRefDirective.ɵfac = function DataRefDirective_Factory(t) { return new (t || DataRefDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DataRefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DataRefDirective, selectors: [["", "dataRef", ""]], inputs: { dataRefFrom: "dataRefFrom" }, exportAs: ["dataRef"] });
DataRefDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef }
];
__decorate([
    Input()
], DataRefDirective.prototype, "dataRefFrom", null);

let CngDataRefModule = class CngDataRefModule {
};
CngDataRefModule.ɵfac = function CngDataRefModule_Factory(t) { return new (t || CngDataRefModule)(); };
CngDataRefModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CngDataRefModule });
CngDataRefModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let EllipsizePipe = class EllipsizePipe {
    transform(value, limit, postString = '...') {
        let substr = value ? value.substring(0, limit) : '';
        if (substr.length !== (value ? value.length : 0)) {
            substr = `${substr}${postString}`;
        }
        return substr;
    }
};
EllipsizePipe.ɵfac = function EllipsizePipe_Factory(t) { return new (t || EllipsizePipe)(); };
EllipsizePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "ellipsize", type: EllipsizePipe, pure: true });

let EllipsizePipeModule = class EllipsizePipeModule {
};
EllipsizePipeModule.ɵfac = function EllipsizePipeModule_Factory(t) { return new (t || EllipsizePipeModule)(); };
EllipsizePipeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: EllipsizePipeModule });
EllipsizePipeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileSizePipe, [{
        type: Pipe,
        args: [{
                name: 'fileSize'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileSizeModule, [{
        type: NgModule,
        args: [{
                declarations: [FileSizePipe],
                exports: [FileSizePipe],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FileSizeModule, { declarations: function () { return [FileSizePipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FileSizePipe]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SkipNavComponent, [{
        type: Component,
        args: [{ selector: 'skip-nav', template: "<div class=\"skip-nav base-padding\" [ngClass]=\"{'active': active}\">\n  <a class=\"text-size-20\"\n    i18n\n    [routerLink]=\"\"\n    [fragment]=\"mainId\"\n    (click)=\"focusMain()\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    tabindex=\"0\">\n    <ng-content></ng-content>\n  </a>\n</div>\n", styles: [".skip-nav{position:fixed;left:0;top:-70px;z-index:9999;background-color:var(--cui-theme-primary);border-radius:0 0 20px;transition:top .2s}.skip-nav a:focus{color:var(--cui-theme-primary-color)}.skip-nav.active{top:0}"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { mainId: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SkipNavModule, [{
        type: NgModule,
        args: [{
                declarations: [SkipNavComponent],
                exports: [SkipNavComponent],
                imports: [
                    CommonModule,
                    RouterModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SkipNavModule, { declarations: function () { return [SkipNavComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [SkipNavComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataRefDirective, [{
        type: Directive,
        args: [{
                selector: '[dataRef]',
                exportAs: 'dataRef'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { dataRefFrom: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CngDataRefModule, [{
        type: NgModule,
        args: [{
                declarations: [DataRefDirective],
                exports: [DataRefDirective],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CngDataRefModule, { declarations: function () { return [DataRefDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DataRefDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EllipsizePipe, [{
        type: Pipe,
        args: [{
                name: 'ellipsize'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EllipsizePipeModule, [{
        type: NgModule,
        args: [{
                declarations: [EllipsizePipe],
                exports: [EllipsizePipe],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EllipsizePipeModule, { declarations: function () { return [EllipsizePipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [EllipsizePipe]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CngDataRefModule, DataRefDirective, EllipsizePipe, EllipsizePipeModule, FileSizeModule, FileSizePipe, SkipNavComponent, SkipNavModule };

